module.exports = __webpack_public_path__ + "static/videoregistroEN-accdf29a04f56401404db53ff326ad50.png";